<div class="row page-header">
    <div class="col-12">
        <h1>
            Purchase Orders
            <small>Manage purchase orders</small>
        </h1>
    </div>
</div>
@if (viewingRecords()) {
    <div [hidden]="isInitialLoading">
        <div class="row">
            <div class="col-lg-12">
                <div class="row action-toolbar">
                    <div class="col-12">
                        <form class="form-inline">
                            <action-toolbar-count [grid]="grid"></action-toolbar-count>
                            <action-toolbar-buttons
                                [grid]="grid"
                                [canEdit]="canEdit"
                                [showAdd]="true"
                                [showEdit]="true"
                                [showDelete]="true"
                                [showDuplicate]="false"
                            >
                            </action-toolbar-buttons>
                            <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                            <grid-export [grid]="mainGrid" [name]="'Purchase Orders'"></grid-export>
                        </form>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <wj-flex-grid
                            id="mainGrid"
                            #mainGrid
                            appAutoSize
                            [padding]="73"
                            (initialized)="grid.initialize(mainGrid)"
                            (destroy)="grid.destroy()"
                            [itemsSource]="grid.view"
                            [itemFormatter]="itemFormatter"
                        >
                            <wj-flex-grid-filter></wj-flex-grid-filter>
                            <wj-flex-grid-column
                                [header]="'Images'"
                                [binding]="'imageUrls'"
                                [cssClass]="'cell-img'"
                                [width]="100"
                                [isReadOnly]="true"
                            >
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                    @for (url of cell.item.imageUrls; track url; let i = $index) {
                                        <img [src]="getExistingImageSrc(url)" (click)="openImage(url)" />
                                    }
                                </ng-template>
                            </wj-flex-grid-column>
                            <wj-flex-grid-column
                                [header]="'Type'"
                                [binding]="'type'"
                                [width]="120"
                                [isReadOnly]="true"
                            >
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                    {{ getTypeDisplay(cell.item.type) }}
                                </ng-template>
                            </wj-flex-grid-column>
                            <wj-flex-grid-column
                                [header]="'Vendor'"
                                [binding]="'vendor'"
                                [dataMap]="vendorMap"
                                [width]="200"
                                [isReadOnly]="true"
                            ></wj-flex-grid-column>
                            <wj-flex-grid-column
                                [header]="'Phase'"
                                [binding]="'phase'"
                                [dataMap]="phaseMap"
                                [width]="200"
                                [isReadOnly]="true"
                            ></wj-flex-grid-column>
                            <wj-flex-grid-column
                                [header]="'Description'"
                                [binding]="'description'"
                                [minWidth]="300"
                                [width]="'*'"
                                [isReadOnly]="true"
                            ></wj-flex-grid-column>
                            <wj-flex-grid-column
                                [header]="'Amount'"
                                [binding]="'amount'"
                                [width]="120"
                                [format]="'c2'"
                                [isReadOnly]="true"
                            ></wj-flex-grid-column>
                            <wj-flex-grid-column
                                [header]="'PO Number'"
                                [binding]="'poNumber'"
                                [width]="150"
                                [isReadOnly]="true"
                            ></wj-flex-grid-column>
                            <wj-flex-grid-column
                                [header]="'Purchaser'"
                                [binding]="'purchaserId'"
                                [dataMap]="allUserMap"
                                [width]="180"
                                [isReadOnly]="true"
                            ></wj-flex-grid-column>
                            <wj-flex-grid-column
                                [header]="'Created On'"
                                [binding]="'createdOn'"
                                [width]="130"
                                [format]="'d'"
                                [isReadOnly]="true"
                            ></wj-flex-grid-column>
                        </wj-flex-grid>
                        <grid-selection-calculation [grid]="mainGrid"></grid-selection-calculation>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
